module.exports = __webpack_public_path__ + "img/page4Img2.7dd40353.png";